import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService, ScApiService, ScuiModalComponent } from '@sc-ui';
import { NotificationsService } from 'src/services/notifications.service';
import { fadeIn } from 'src/transitions';
import { LocalizationService } from 'src/services/localization.service';
import { DemoService } from 'src/services/demo.service';
import { texts } from './project.texts';

@Component({
  standalone: false,
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
  animations: [fadeIn]
})
export class ProjectComponent implements OnInit {

  texts = texts;

  state = 'out';

  id: any;

  shouldGenerateContent = false;

  project: any;

  notifications: any;

  chatStarted = false;

  view = 'base';

  // ?obfuscate hides real customer data for demos and screenshots
  obfuscate = false;

  progress = 'prepared';

  @ViewChild(ScuiModalComponent, { static: true })
  modal: ScuiModalComponent;

  constructor(
    private api: ScApiService,
    private events: EventService,
    private notificationService: NotificationsService,
    public loc: LocalizationService,
    public demo: DemoService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {

    this.route.queryParams.subscribe((params: any) => {
      this.view = params.view ?? 'base';
      this.obfuscate = params.obfuscate != null;
      this.applyObfuscation();
    });

    this.route.params.subscribe((params: any) => {

      if (params.id && params.id != this.id) {

        this.id = params.id;
        this.events.channel('projects/' + this.id).subscribe(() => this.load());
        this.load();
      }
    });
  }

  load() {
    this.api.get('projects/' + this.id).subscribe((d: any) => {
      this.project = d;
      this.applyObfuscation();
      this.state = 'in';

      var isStarted = d.Status == 'AwaitingSourcing' || d.Status == 'Sourcing' || d.Status == 'Completed';
      if (isStarted) this.progress = 'applications';
    });

    this.api.get('projects/' + this.id + '/notifications').subscribe(d => {
      this.notifications = d;
    });

     
  }

  applyObfuscation() {
    if (!this.obfuscate || !this.project) return;
    this.project.Name = 'Lead Consultant Product';
  }

  activateView(v) {
    var uri = '/projects/' + this.id + '?view=' + v;
    if (this.obfuscate) uri += '&obfuscate=1';
    this.router.navigateByUrl(uri);
  }

  execute(i) {
    this.notificationService.execute(i);
    this.modal.complete(null);
  }

}
